var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('Banner',{staticClass:"mb-10"}),_c('Service'),_c('Puzzle',{staticClass:"mt-200 mb-200"}),_c('Product'),_c('Partner'),_c('How'),_c('Talk',{staticClass:"mb-4 mt-3"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }